import { Injectable } from '@angular/core';
import { INavData } from '@coreui/angular-pro';
import { MenuService as BaseMenuService } from 'app';

@Injectable({
  providedIn: 'root',
})
export class MenuService extends BaseMenuService<INavData> {
  
  constructor() {
      super();
  }

  protected createNavItems(lang: string, t: (key: string) => string): INavData[] {
    return [
      {
        name: t('dashboard'),
        url: '/'+lang+'/dashboard',
        iconComponent: { name: 'cil-speedometer' }
      },
      {
        name: t('menu.info'),
        url: `/${lang}/media/info`,
        iconComponent: { name: 'info' }
      },
      {
        name: t('order_products'),
        url: '/'+lang+'/order-wizard',
        iconComponent: { name: 'cil-cart' }
      },
      {
        name: t('my_orders'),
        url: '/'+lang+'/my-orders',
        iconComponent: { name: 'cil-list' }
      },
    ];
  }
}